import React from 'react'
import ErrorStatusIcon from './ErrorStatusIcon'

const FailedStatusIcon = () => <ErrorStatusIcon />

export default FailedStatusIcon
